import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { UserListHead } from 'src/sections/@dashboard/user';

const ScheduledPostGridHead = ({ scheduledPostList, order, orderBy, handleRequestSort }) => {
    const { t: translate } = useTranslation();
  const getTableDesk = [
    { id: 'scheduled_time', width: '5%', label: translate('approval.tab.scheduled_time'), alignRight: false, hasSort: true },
    { id: 'created_time', width: '5%', label: translate('approval.tab.created_time'), alignRight: false, hasSort: true },
    { id: 'updated_at', width: '5%', label: translate('approval.tab.updated_at'), alignRight: false, hasSort: true },
    { id: 'post_status', width: '10%', label: translate('approval.tab.post_status'), alignRight: false, hasSort: false },
    { id: 'description', width: '10%', label: translate('approval.tab.post_content'), alignRight: false, hasSort: true },
    { id: 'media', width: '10%', label: translate('approval.tab.media'), alignRight: false },
    { id: 'created_by_name', width: '10%', label: translate('approval.tab.created_by'), alignRight: false, hasSort: true },
    { id: 'approved_by_name', width: '10%', label: translate('upcoming_post.approved_by'), alignRight: false, hasSort: true },
    { id: 'is_enabled', width: '10%', label: translate('common.status'), alignRight: false, hasSort: true },
    { id: 'scheduled-for', width: '25%', label: translate('approval.tab.scheduled_for'), alignRight: false },
    { id: 'action', width: '10%', label: translate('approval.tab.action'), alignCenter: true },
  ];
  const getTableMobile = [
    { id: 'scheduled-on', label: translate('approval.tab.scheduled_time'), alignRight: false, hasSort: true },
    { id: 'post-content', label: translate('approval.tab.post_content'), alignRight: false, hasSort: true },
    { id: 'action', label: translate('approval.tab.action'), alignRight: false },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const TABLE_HEAD = isMobile ? getTableMobile : getTableDesk;

  return (
    <UserListHead
      order={order}
      orderBy={orderBy}
      headLabel={TABLE_HEAD}
      rowCount={scheduledPostList.length}
      onRequestSort={handleRequestSort}
      style={{ whiteSpace: 'nowrap' }}
      isShowCheckbox={false}
    />
  );
};

export default ScheduledPostGridHead;
